import { getJwtCookie } from '../jwt'
import elmElement from '../elm_element'
import IntersectionObserverPorts from '../intersection_observer'
import { Elm } from '../../elm/Carwow/StockDealCard.elm'

getJwtCookie().then(jwt => {
  elmElement('carwow-stock-deal-card', Elm.Carwow.StockDealCard, {

    setupPorts (ports) {
      IntersectionObserverPorts(ports)
    },

    bugsnagRedactFlags: [],

    mapFlags (flags) {
      return Object.assign(flags, {
        jwt,
        userLocation: JSON.parse(flags.userLocation),
        hideDistance: JSON.parse(flags.hideDistance),
        dataAttributes: JSON.parse(flags.dataAttributes),
        badge: flags.badge || null
      })
    }
  })
})

/*
  Register volume errors for carwow-stock-deal-card. Occasional timeouts on load can
  be handled in Honeycomb instead.
*/
if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
  window.Carwow.registerBugsnagVolumeError((error) => {
    const components = ['carwow-stock-deal-card']
    const cardComponent = components.some(component => error.errorClass.includes(component))
    const messages = [
      'Http.Timeout @',
      'Http.BadStatus: 401 @',
      'Http.BadStatus: 403 @',
      'Http.BadStatus: 404 @',
      'Http.BadStatus: 500 @',
      'Http.BadStatus: 502 @',
      'Http.BadStatus: 503 @',
      'Http.BadStatus: 504 @',
      'Http.BadBody @',
      'Http.NetworkError @'
    ]
    const validError = messages.some(message => error.errorMessage.includes(message))

    return cardComponent && validError
  })
}
